import React from "react";

function WarningPop({ iconClassName, warningMsg }) {
  return (
    <div className="text-center">
      {iconClassName && <i className={iconClassName + " " + "manage-icon bg-icon"}></i>}
      <div className="d-flex justify-content-center mt-1">
        <span className="text-doctor">{warningMsg}</span>
      </div>
    </div>
  );
}

export default WarningPop;
